import request from '@/utils/request'; // 广告数据展示--账号

export function getAdvOriginList(data) {
  return request({
    url: '/datum/ad_action_list',
    method: 'get',
    params: data
  });
}